<template>
  <base-page>
    <el-dialog :before-close="handleClose" title="Selecteaza masina pentru programare" :visible="true" width="70%" append-to-body>
        <el-select size="large" class="full-width" 
              placeholder="Cauta dupa numar inmatriculare, nume, telefon sau email"
              remote
              ref="focusShow"
              :remote-method="handleFindProdus"
              v-model="IdMasinaSelectataProgramareDirect"
              filterable>
                <el-option
                  v-for="item in Info.masini"
                  :key="'lista_masini'+item.Id"
                  :id="'produs_cu_stoc'"
                  :name="'Client: ' + item.Nume + ' ' + item.Prenume + ' Telefon: ' + item.Telefon"
                :label="'Auto: ' + item.Numar + (item.MarcaNume !== null && item.MarcaNume !== ''? (' - ' + item.MarcaNume) : '') + (item.ModelNume!==null && item.ModelNume !== '' ? (' ' + item.ModelNume): '')"
                :value="item.Id">
              </el-option>1
            </el-select>
        <span slot="footer" class="dialog-footer" >   
            <el-button size="small" :disabled="this.IdMasinaSelectataProgramareDirect == ''" type="success" @click="adauga_programarea_direct()" >Programeaza</el-button>
        </span>
        <programari v-show="false" ref="dlg_rez" />
    </el-dialog>
  </base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import Rezervari_dialog from "@/pages/Receptie/Rezervari_list.vue";

export default {
  name: "adauga_rezervare_dialog",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "programari": Rezervari_dialog,
  },
  data() {
    return {
      IdMasinaSelectataProgramareDirect: '',
      Results: [],
      vine_de_la: '',
      Info: {
        masini:[],
      }
    };
  },
  methods: {

    handleClose() {
      this.$router.go(-1)
    },

    async  handleFindProdus(data) {
      if (data !== '') {
        await new Promise(resolve => setTimeout(resolve, 200)); 
        var result = await this.post("admin/clienti/remoteFindProdus", { string: data});
        if(result){
          this.Info.masini = result.masini;
        }
      }
    },
  
    async adauga_programarea_direct() {

      let masina_selectata_direct = this.Info.masini.filter((value) => value.Id == this.IdMasinaSelectataProgramareDirect)[0];

      this.$refs.dlg_rez.programeaza_masina(masina_selectata_direct, "da");

      this.IdMasinaSelectataProgramareDirect = null;
      this.Info.masini = [];

    },    


  
  },
  mounted() {

    // console.log(BasePage)
    // if (!this.$has_right("Management")) {
    //   this.$router.push("/no-rights");
    //   return;
    // }
    // this.base_url = settings.BASE_URL;
    // this.get_info();
  },
};
</script>

<style lang="less" scoped>
.top50 {
  margin-top: 20px;
}

#produs_cu_stoc:after {
  content: attr(name);
  width: auto;
  max-height: 27px !important;
  color: rgb(0, 0, 0);
  display: flex;
  justify-content: center;
  align-items: center;
  float: right;
  font-size: 12px !important;
  padding: 0 5px;
  margin: 2px 0;
  border: 1px solid transparent;
  border-radius: 7px;
  background-color: #d6dee5a1;
}

.filtre {
  .el-input-number {
    width: 100% !important;
  }
}

.input-element {
  width: 23%;
  margin-right: 2%;
}

@media only screen and (max-width: 600px) {
  .input-element {
    width: 80%;
  }

  .el-tooltip__popper {
    width: 90%;
  }
}
</style>
